import { isIntervalKeyPoseRecord } from './keyPoseSelectors';
import type { KeyPoseRecord } from './types';

/** Mid-tone ghost tint for user key poses. */
export const USER_KEY_POSE_GHOST_COLOR = '#92501f';
export const USER_KEY_POSE_GHOST_OPACITY = 0.23;

/** Lighter orange ghost tint for auto-generated control frames. */
export const INTERVAL_KEY_POSE_GHOST_COLOR = '#d4924a';
export const INTERVAL_KEY_POSE_GHOST_OPACITY = 0.27;

export const DEFAULT_KEY_POSE_GHOST_COLOR = '#222222';
export const DEFAULT_KEY_POSE_GHOST_OPACITY = 0.24;

export function resolveKeyPoseGhostTint(
  keyPose: Pick<KeyPoseRecord, 'id' | 'stamp'>,
): { color: string; opacity: number } {
  if (isIntervalKeyPoseRecord(keyPose)) {
    return {
      color: INTERVAL_KEY_POSE_GHOST_COLOR,
      opacity: INTERVAL_KEY_POSE_GHOST_OPACITY,
    };
  }

  return {
    color: USER_KEY_POSE_GHOST_COLOR,
    opacity: USER_KEY_POSE_GHOST_OPACITY,
  };
}
